module.exports = __webpack_public_path__ + "img/12.1salesreturnflow01.034c8ddb.svg";